module.exports = __webpack_public_path__ + "media/images/area/icon_weather_15-86061327e1cd1fff09c5567365b4add6.png";